import { render, staticRenderFns } from "./InfosetExportTabs.vue?vue&type=template&id=b08902ac&"
import script from "./InfosetExportTabs.vue?vue&type=script&lang=ts&"
export * from "./InfosetExportTabs.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetExportTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports